import useListTicket from 'app/pages/NewAccount/hooks/useListTicket';
import ListTicketLayout from 'app/pages/NewAccount/layouts/ListTicketLayout';
import {
  ListTicketViewProps,
  ListTicketViewRef,
} from 'app/pages/NewAccount/types';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

const ListWaitForComplete = forwardRef<ListTicketViewRef, ListTicketViewProps>(
  ({ activeKeyTab, loading, setLoading }, ref) => {
    const isActiveCurrentTab = activeKeyTab === 'tab-4';
    const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

    const {
      listTicket: listTicketWaitForComplete,
      paginator,
      search,
      optionsGetListOrder,
    } = useListTicket({
      orderState: 'init',
      isActiveTab: activeKeyTab === 'tab-4',
      setLoading,
      onFinally: () => {
        setIsDisplayData(true);
      },
    });

    useImperativeHandle(ref, () => {
      return {
        search,
        getCurrentSearchOpt: () => optionsGetListOrder,
      };
    });

    useEffect(() => {
      if (!isActiveCurrentTab) setIsDisplayData(false);
    }, [isActiveCurrentTab]);

    return (
      <ListTicketLayout
        loading={loading}
        paginator={paginator}
        listTicket={isDisplayData ? listTicketWaitForComplete : []}
        search={search}
        orderState="init"
        setIsLoading={setLoading}
        activeKeyTab={activeKeyTab}
      />
    );
  },
);

export default ListWaitForComplete;
